<template>
    <div class="modal-overlay" @click.self="close">
        <div class="modal">
            <img class="modal-icon" :src="informationIcon" alt="Ícone de informação" />
            <p class="modal-message">{{ props.message }}</p>
            <button class="btn-confirm" @click="confirm">OK</button>
        </div>
    </div>
</template>
  
<script setup>
import informationIcon from '@/assets/icons/information.svg';

const props = defineProps({message: {type: String, required: true}});
const emits = defineEmits(['confirmed', 'close']);

function confirm() {
    emits('confirmed'); 
    close();
}

function close() {emits('close');}
</script>
  
<style scoped>
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
}

.modal {
    background: #fff;
    padding: 30px;
    border-radius: 8px;
    text-align: center;
    max-width: 90%;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.modal-icon {
    width: 50px;
    height: 50px;
    margin-bottom: 20px;
}

.modal-message {
    font-size: 18px;
    margin-bottom: 20px;
}

.modal-button {
    padding: 10px 20px;
    font-size: 16px;
    border: none;
    border-radius: 4px;
    background-color: #3498db;
    color: #fff;
    cursor: pointer;
    transition: background-color 0.3s;
}

.modal-button:hover {
    background-color: #2980b9;
}
</style>
  